import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../config/supabase'
import Layout from '../layout/Layout'
import Card from '../ui/Card'
import toast from 'react-hot-toast'

const EmailConfirmationHandler = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleEmailConfirmation = async () => {
      try {
        console.log('🔐 Handling email confirmation...')
        
        // Get the current session after email confirmation
        const { data, error } = await supabase.auth.getSession()
        
        if (error) {
          console.error('❌ Email confirmation error:', error)
          toast.error('Email confirmation failed. Please try again.')
          navigate('/login')
          return
        }

        if (data.session) {
          console.log('✅ Email confirmed successfully:', data.session.user.email)
          toast.success('Email confirmed successfully! Welcome to Chore Haven! 🎉')
          
          // Add a small delay to ensure the auth state is fully updated
          setTimeout(() => {
            console.log('🚀 Navigating after email confirmation...')
            // The routing logic will handle whether user goes to onboarding or dashboard
            navigate('/dashboard', { replace: true })
          }, 1500)
        } else {
          console.log('❌ No session found, redirecting to login')
          toast.error('Email confirmation failed. Please try signing in.')
          navigate('/login')
        }
      } catch (error) {
        console.error('💥 Unexpected error during email confirmation:', error)
        toast.error('An error occurred during email confirmation.')
        navigate('/login')
      }
    }

    handleEmailConfirmation()
  }, [navigate])

  return (
    <Layout showNavbar={false}>
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <Card className="text-center max-w-md w-full">
          <div className="text-6xl mb-4">📧</div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            Confirming Your Email
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Please wait while we confirm your email address and set up your Chore Haven account...
          </p>
          <div className="w-12 h-12 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
          
          {/* Progress indicator */}
          <div className="mt-6 space-y-2">
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span>Verifying your email...</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
              <div className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></div>
              <span>Setting up your account...</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
              <div className="w-2 h-2 bg-secondary-500 rounded-full animate-pulse"></div>
              <span>Preparing your dashboard...</span>
            </div>
          </div>
        </Card>
      </div>
    </Layout>
  )
}

export default EmailConfirmationHandler